<template>
  <b-modal :id="modalId" class="modal-content center" @hide="backToPath ? $router.push(backToPath) : null" centered :hide-header="true" :hide-footer="true" style="width:60%; top: 50%">
			<div class="modal-inner">
				<p class="modal-ttl">{{content}}</p>
				<div class="modal-btn-area clearfix">
					<div class="btn-base pos-center">
						<a href="javascript:;" @click="$bvModal.hide(modalId)"><p>{{ $t('ok') }}</p></a>
					</div>
				</div>
			</div>
		</b-modal>
</template>

<script>
  import { BModal, VBModal, BButton } from 'bootstrap-vue'
  export default {
    props: ['modalId', 'content', 'backToPath'],
    components: { BModal, BButton },
    directives: { BModal, VBModal, BButton },
  }
</script>